import React from 'react';
import PropTypes from 'prop-types';
import sharedStyles from '../../../styles/shared.css';
import StatNumber from '../../stat-number';
import Tooltip from '../../tooltip';
import SentimentSparkLine from '../sentiment-spark-line';
import RatingsDistributionChart from '../ratings-distribution-chart';
import { StationCategoryRatingType, StationCategoryRatingComparisonType } from '../../../utils/prop-types/rating-types';

class RatingsPerformanceContent extends React.Component {
  static propTypes = {
    stats: PropTypes.arrayOf(StationCategoryRatingType),
    comparisonStats: PropTypes.arrayOf(StationCategoryRatingComparisonType),
    ratingCategories: PropTypes.arrayOf(StationCategoryRatingComparisonType),
    comparisonMetricName: PropTypes.string,
  }

  static defaultProps = {
    stats: {},
    comparisonStats: {},
    ratingCategories: {},
    comparisonMetricName: '',
  }

  static renderRatingCategoryRow(stat, maxRating, comparisonStatsMap, ratingCategoriesMap) {
    const comparisonStat = (comparisonStatsMap || {})[stat.category_id] || {};
    const categoryName = ratingCategoriesMap[stat.category_id].name;
    const comparisonTotalRatings = comparisonStat.positive + comparisonStat.negative + comparisonStat.neutral;

    return (
      <tr key={categoryName} className="engagement-category">
        <td>
          {categoryName}
        </td>
        <td>
          <SentimentSparkLine recentRatings={stat.recent_ratings} />
        </td>
        <td className="col-start rating-distribution-bars">
          <RatingsDistributionChart
            ratings={{
              positive: stat.positive,
              negative: stat.negative,
              neutral: stat.neutral,
            }}
            maxRatingCount={maxRating}
          />
        </td>
        <td>
          {stat.total_ratings}
        </td>
        <td className="comparison category-comparison">
          <StatNumber
            statType={categoryName}
            value={stat.total_ratings}
            compareTo={comparisonTotalRatings}
            showDifference
          />
        </td>
      </tr>
    );
  }

  render() {
    const { stats, comparisonMetricName, comparisonStats, ratingCategories } = this.props;

    const comparisonStatsMap = _.keyBy(comparisonStats, 'category_id');
    const ratingCategoriesMap = _.keyBy(ratingCategories, 'id');

    let maxRating = 0;
    stats.forEach((rating) => {
      maxRating = Math.max(maxRating, rating.positive, rating.negative, rating.neutral);
    });

    return (
      <table className={sharedStyles.stripedTable}>
        <thead>
          <tr>
            <th>
              Rating Category
            </th>
            <th>
              <span id="ratingPerfLast5">
                Last 5 Ratings
              </span>
              <Tooltip
                tootipContent="Most recent 5 ratings based off selected date range."
                uniqueTargetSelector="#ratingPerfLast5"
              />
            </th>
            <th>
              <span id="ratingPerfDistribution">
                Rating Distribution
              </span>
              <Tooltip
                tootipContent="Ratings Distribution is a breakdown of the rating types."
                uniqueTargetSelector="#ratingPerfDistribution"
              />
            </th>
            <th>
              <span id="ratingPerfTotalRatings">
                Total Ratings
              </span>
              <Tooltip
                tootipContent="Total ratings is the total number of ratings this station has received for a given Rating Category."
                uniqueTargetSelector="#ratingPerfTotalRatings"
              />
            </th>
            <th>
              <div id="comparisonMetricSelectContainer" className="comparison-metric-container">
                <span>COMPARE TO</span>
                <br />
                <span>{comparisonMetricName}</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {stats.map(
            statRow => RatingsPerformanceContent.renderRatingCategoryRow(
              statRow, maxRating, comparisonStatsMap, ratingCategoriesMap,
            ),
          )}
        </tbody>
      </table>
    );
  }
}

export default RatingsPerformanceContent;
